<script setup lang="ts"></script>

<template>
  <icon name="lucide:send" />
</template>

<style scoped></style>
